import React from "react"

import { AvaGaebPhase } from "shared/types/AvaGaebPhase"

import { ProjectGaebOverlayView } from "./ProjectGaebOverlayView"
import { useProjectGaebOverlayViewModel } from "./hooks/useProjectGaebOverlayViewModel"

export interface ProjectGaebPayload {
  projectID: string
  isShareID?: boolean
}

export interface ProjectGaebOverlayModel {
  onSubmit: (formData: ProjectGaebExportFormData) => void
  onCancel: () => void
}

export interface ProjectGaebOverlayProps extends ProjectGaebOverlayModel {
  autoFocus?: boolean
}

export interface ProjectGaebExportFormData {
  phase: AvaGaebPhase
}

export const ProjectGaebOverlay = React.memo(
  (props: ProjectGaebOverlayProps) => (
    <ProjectGaebOverlayView {...useProjectGaebOverlayViewModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROJECT_GAEB_OVERLAY: ProjectGaebPayload
  }
}
